import React, { useEffect } from 'react'

import { HYPOTHESIS_TRANSCRIPT } from './transcript.constants'
import { useTranscript } from './TranscriptContext'
import { useTranslation } from './hooks/useTranslation'
import { TranscriptHeader } from './TranscriptHeader'
import { TranscriptBlocks } from './TranscriptBlocks'

import './Transcript.scss'

export const Transcript = ({
  metadata = {},
  hardSelectedEvent = null,
  handleTimestampClick = null,
  enableAutoScroll = false,
  showTranslateFeature = false,
}) => {
  const {
    showTranscriptSelector,
    transcriptToDisplay,
    transcriptSelectorOptions,
    transcriptBlockRef,
    showTranscriptHypothesis,
    closestTranscriptIndexRef,
    transcriptType,
    searchQuery,
    allowAutoScroll,
    handleAllowAutoScrollChange,
    handleTranscriptSelectionChange,
    handleSearchTranscript,
    searchMatches,
    currentSearchIndex,
    handleNextSearchMatch,
    handlePreviousSearchMatch,
    handleClearSearch,
    matchIndicesMap,
    shouldScrollToSearchMatch,
    scrollToCurrentSearchMatch,
    highlightedTranscriptIndex,
    comments,
  } = useTranscript()

  const {
    translationState,
    selectedLanguage,
    translatedLanguages,
    displayTranscript,
    handleLanguageChange,
    handleShowOriginal,
  } = useTranslation(transcriptType, transcriptToDisplay)

  useEffect(() => {
    if (shouldScrollToSearchMatch) {
      scrollToCurrentSearchMatch()
    }
  })

  return (
    <>
      <TranscriptHeader
        searchQuery={searchQuery}
        handleSearchTranscript={handleSearchTranscript}
        handleAllowAutoScrollChange={handleAllowAutoScrollChange}
        showTranscriptSelector={showTranscriptSelector}
        enableAutoScroll={enableAutoScroll}
        allowAutoScroll={allowAutoScroll}
        transcriptSelectorOptions={transcriptSelectorOptions}
        handleTranscriptSelectionChange={handleTranscriptSelectionChange}
        transcriptType={transcriptType}
        totalMatches={searchMatches.length}
        currentSearchIndex={currentSearchIndex}
        handleNextSearchMatch={handleNextSearchMatch}
        handlePreviousSearchMatch={handlePreviousSearchMatch}
        handleClearSearch={handleClearSearch}
        showTranslateFeature={showTranslateFeature && transcriptType !== HYPOTHESIS_TRANSCRIPT}
        onLanguageChange={handleLanguageChange}
        onShowOriginal={handleShowOriginal}
        translationState={translationState}
        selectedLanguage={selectedLanguage}
        translatedLanguages={translatedLanguages}
      />
      <div data-testid="transcript" id="transcript-viewer" className="transcript">
        <TranscriptBlocks
          transcriptBlockRef={transcriptBlockRef}
          transcript={displayTranscript}
          handleTimestampClick={handleTimestampClick}
          showTranscriptHypothesis={showTranscriptHypothesis}
          closestTranscriptIndexRef={closestTranscriptIndexRef}
          searchQuery={searchQuery}
          hardSelectedEvent={hardSelectedEvent}
          metadata={metadata}
          searchMatches={searchMatches}
          currentSearchIndex={currentSearchIndex}
          matchIndicesMap={matchIndicesMap}
          highlightedTranscriptIndex={highlightedTranscriptIndex}
          isTranslating={translationState === 'translating'}
          comments={comments}
        />
      </div>
    </>
  )
}
